var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h100-60 noPage"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"calc(100% - 80px)","rowSelected":_vm.watchRowSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }